// pt-PT source of truth for the settings area (Configuração Global, Campos da
// ficha, Integração SISTRADE e Painel). English mirrors this in ../en/settings.ts.
export const settings = {
  common: {
    saving: 'A guardar…',
    saved: 'Guardado ✓',
    moveUp: 'Subir',
    moveDown: 'Descer',
  },
  global: {
    title: 'Configuração Global',
    subtitle: 'Dados da instituição, locais e imagem do portal',
    adminOnly: 'Esta área é reservada a administradores do portal.',
    institution: 'Instituição',
    name: 'Nome da instituição',
    nif: 'NIF',
    phone: 'Telefone fixo',
    mobile: 'Telemóvel',
    email: 'Email',
    branding: 'Imagem do portal',
    noImage: 'Sem imagem',
    upload: 'Carregar',
    imageTooLarge: 'Imagem demasiado grande (máx. 4 MB).',
    imageReadError: 'Não foi possível ler a imagem.',
    asset: {
      logo: { label: 'Logótipo (ecrã de login)', hint: 'PNG/SVG com fundo transparente' },
      icon: { label: 'Ícone da webapp (favicon)', hint: 'Imagem quadrada pequena' },
      loginBackground: { label: 'Fundo do ecrã de login', hint: 'Imagem de fundo' },
    },
    locations: 'Locais',
    deleteLocationConfirm: 'Eliminar este local?',
    locName: 'Nome *',
    locNamePlaceholder: 'Sede',
    locAbbr: 'Abreviatura',
    locAbbrPlaceholder: 'SD',
    locAddress: 'Morada',
    colName: 'Nome',
    colAbbr: 'Abreviatura',
    colAddress: 'Morada',
  },
  fields: {
    title: 'Campos da ficha',
    subtitle: 'Separadores, campos, obrigatórios, reservados e onboarding',
    translateMissing: 'Traduzir campos em falta',
    translateMissingNone: 'Não há rótulos por traduzir.',
    translateMissingDone: '{n} rótulos traduzidos.',
    intro: {
      lead: 'Gestão central da ficha. Os campos base vêm do SISTRADE; aqui pode organizar os ',
      tabs: 'separadores',
      afterTabs:
        ' (criar, renomear, ordenar), mover cada campo para o separador certo, reordenar, e marcar quais são ',
      required: 'obrigatórios',
      afterRequired: ', ',
      reserved: 'reservados',
      afterReserved: ' ou aparecem no formulário de ',
      onboarding: 'onboarding',
      afterOnboarding:
        ' (o que o novo colaborador preenche pelo link). A obrigatoriedade no onboarding é a mesma marcada aqui.',
    },
    type: {
      text: 'Texto',
      longText: 'Texto longo',
      number: 'Número',
      integer: 'Inteiro',
      date: 'Data',
      dateTime: 'Data/hora',
      boolean: 'Sim/Não',
      select: 'Seleção',
      multiSelect: 'Seleção múltipla',
      email: 'Email',
      phone: 'Telefone',
      url: 'URL',
      currency: 'Moeda (EUR)',
      percent: 'Percentagem',
    },
    moveSectionUp: 'Subir separador',
    moveSectionDown: 'Descer separador',
    rename: 'Renomear',
    renamePrompt: 'Novo nome do separador',
    sectionReservedHint: 'Secção visível só a quem tem permissão',
    reservedLabel: 'reservada',
    noFields: 'Sem campos nesta secção.',
    baseTag: 'base',
    fieldCount: '{n} campos',
    fieldCountOne: '1 campo',
    expandSection: 'Expandir separador',
    collapseSection: 'Recolher separador',
    flag: {
      required: 'Obrigatório',
      reserved: 'Reservado',
      onboarding: 'Onboarding',
    },
    removeConfirm: 'Desativar este campo? Os valores existentes são mantidos.',
    col: {
      field: 'Campo',
      type: 'Tipo',
      required: 'Obrig.',
      reserved: 'Reserv.',
      onboarding: 'Onboarding',
      onboardingHint: 'Aparece no formulário de onboarding (novo colaborador)',
      section: 'Separador',
      order: 'Ordem',
    },
    newSection: '+ Novo separador',
    newSectionTitle: 'Novo separador',
    sectionName: 'Nome do separador',
    createSection: 'Criar separador',
    creating: 'A criar…',
    newField: '+ Novo campo',
    newFieldIn: 'Novo campo em “{section}”',
    fieldName: 'Nome do campo',
    typeLabel: 'Tipo',
    options: 'Opções',
    optionsPlaceholder: 'Opção A\nOpção B',
    requiredField: 'Campo obrigatório',
    reservedField: 'Campo reservado (só visível a quem tem permissão)',
    onboardingField: 'Aparece no formulário de onboarding (novo colaborador)',
    createField: 'Criar campo',
  },
  sistrade: {
    title: 'Integração SISTRADE',
    subtitle: 'Estado da ligação e sincronização de colaboradores',
    mode: 'Modo',
    configured: 'Configurado',
    baseUrl: 'Base URL',
    pullTitle: 'Sincronizar do SISTRADE (pull)',
    pullDesc:
      'Puxa os colaboradores ativos do SISTRADE e atualiza as fichas no portal (cria os novos, atualiza os existentes por código).',
    syncing: 'A sincronizar…',
    syncCollaborators: 'Sincronizar colaboradores',
    running:
      'A sincronização corre em segundo plano — podes sair desta página; o estado é atualizado aqui automaticamente.',
    resultBase: '{total} colaboradores — {created} criados, {updated} atualizados',
    resultSkipped: ', {skipped} ignorados',
    resultFields: ', {fields} campos preenchidos',
    resultReduced: ' (dados reduzidos da API)',
    syncFailed: 'A sincronização falhou: {error}.',
    unknownError: 'erro desconhecido',
    adminOnly: 'A sincronização com o SISTRADE é reservada a administradores do portal.',
    teamsTitle: 'Sincronização agendada de equipas',
    teamsDesc:
      'As equipas e linhas de investigação são guardadas na base de dados do portal e atualizadas automaticamente a partir do SISTRADE. Última sincronização:',
    never: 'nunca',
    autoSync: 'Sincronizar automaticamente',
    every: 'A cada',
    hours: 'horas',
    syncTeamsNow: 'Sincronizar equipas agora',
    teamsSyncFailed: 'Sincronização de equipas falhou: {error}',
  },
  dashboard: {
    title: 'Painel',
    subtitle:
      'Cards e gráficos que cada destinatário vê no Painel — por perfil, grupo (AD) ou pessoa',
    sectionTitleLabel: 'Título da secção de cards',
    noGroups: 'Sem grupos AD',
    pickPerson: 'Escolher pessoa…',
    pickSubjectError: 'Escolha o destinatário (perfil, grupo ou pessoa).',
    emptyWithSubject:
      'Sem cards para este destinatário. O Painel mostra os indicadores base; adicione cards para o personalizar.',
    emptyNoSubject:
      'Escolha um destinatário (perfil, grupo ou pessoa) para configurar os seus cards.',
    badgeCount: 'Contagem',
    badgeChart: 'Gráfico',
    cardTitle: 'Título',
    chartLabel: 'Gráfico',
    addCount: '+ Contagem',
    addChart: '+ Gráfico',
    newCount: 'Nova contagem',
    subject: {
      role: 'Perfil',
      group: 'Grupo',
      person: 'Pessoa',
    },
    role: {
      onboarding: 'Onboarding',
      hr: 'Recursos Humanos',
      researcher: 'Investigador',
      direction: 'Direção',
      admin: 'Administração',
    },
    source: {
      label: 'Fonte',
      people: 'Colaboradores',
      articles: 'Publicações',
    },
    chart: {
      started: 'Contratos iniciados',
      ended: 'Contratos terminados',
      yearCompare: 'Ano anterior vs atual',
      fieldDistribution: 'Distribuição por campo',
      pubsByYear: 'Publicações por ano',
      pubsByMonth: 'Publicações por mês (ano atual)',
      pubsYearCompare: 'Publicações: ano anterior vs atual',
      quartileDist: 'Distribuição por quartil',
      pubsByTeam: 'Publicações por equipa',
      topResearchers: 'Top investigadores',
      citationsByYear: 'Citações por ano',
    },
    metricLabel: 'Métrica',
    metric: {
      count: 'Publicações (total)',
      citations: 'Citações (total)',
      citationsPerPub: 'Citações por publicação',
      percentQ1: '% em Q1',
      percentQ1Q2: '% em Q1+Q2',
      percentOpenAccess: '% Acesso aberto',
      researchers: 'Investigadores com publicações',
      pubsPerResearcher: 'Publicações por investigador',
      pubsThisYear: 'Publicações no ano atual',
      pubsGrowthRate: 'Taxa de crescimento prevista',
    },
    field: 'Campo',
    value: 'Valor',
    valuePlaceholder: 'valor…',
    match: 'Correspondência',
    matchEq: 'Igual',
    matchNe: 'Diferente (≠)',
    matchContains: 'Contém',
    chartStyle: 'Estilo',
    style: {
      bar: 'Barras',
      hbar: 'Barras horizontais',
      donut: 'Donut',
    },
    appearance: 'Aspeto',
    icon: 'Ícone',
    activeOnly: 'Apenas colaboradores ativos',
  },
  it: {
    intro:
      'Ferramentas de TI: entrar na aplicação como um utilizador para reproduzir ou ajudar com o que ele vê, e gerir quem são os administradores de TI. A impersonação dá acesso efetivo global e fica registada.',
    impersonate: {
      title: 'Entrar como utilizador',
      hint: 'Escolha o colaborador e os papéis a assumir. Nunca Admin nem outro Admin IT.',
      searchPlaceholder: 'Procurar por nome ou email…',
      noResults: 'Sem colaboradores com email profissional.',
      rolesLabel: 'Papéis a assumir',
      start: 'Entrar como {name}',
      starting: 'A entrar…',
    },
    role: {
      researcher: 'Investigador',
      onboarding: 'Onboarding',
      hr: 'Recursos Humanos',
      direction: 'Direção',
    },
    list: {
      title: 'Administradores de TI',
      hint: 'Contas que podem impersonar utilizadores. Mantenha a lista curta.',
      usernamePlaceholder: 'username (ex.: nome@ciimar.up.pt)',
      namePlaceholder: 'Nome (opcional)',
      add: 'Adicionar',
      removeConfirm: 'Remover {username} dos administradores de TI?',
    },
  },
};
